import { useCallback, useState } from 'react'
import { InputText } from 'ui_kit_qmd'
import { styles, text } from './Constants'
import './PaymentInfo.scss'
import 'react-calendar/dist/Calendar.css'
import { getVisitCreditTotal, getVisitTotal } from './utils'

const onlyNumbersRegex = /^\d*\.?\d*$/

type Props = {
  creditAmount?: number
  price: string
  priceError: string
  setPrice: (price: string) => void
}

export function PaymentInfo({ price, priceError, setPrice, creditAmount }: Props) {
  const [currentPrice, setCurrentPrice] = useState(Number(price).toFixed(2))
  const updatePrice = useCallback(
    (value: string) => {
      if (value.match(onlyNumbersRegex) && value !== '.') {
        setCurrentPrice(value)
        setPrice(value)
      }
    },
    [setPrice],
  )

  if (creditAmount === undefined) {
    return <div>Loading...</div>
  }

  const currentPriceNumber = Number(currentPrice)
  const visitCreditTotal = getVisitCreditTotal(currentPriceNumber, creditAmount)
  const visitTotal = getVisitTotal(currentPriceNumber, creditAmount)

  return (
    <div className='review-book-visit-payment-info-container'>
      <label htmlFor='null' className='review-book-visit-payment-info-title'>
        {text.SUMMARY}
      </label>
      <div className='review-book-visit-payment-info-money-container'>
        <InputText
          id='new-visit-price'
          containerStyle={styles.PRICE_INPUT_CONTAINER}
          label={text.VISIT_COST}
          view='visitType'
          type='numeric'
          setValue={updatePrice}
          value={currentPrice}
          isError={priceError}
          localError={priceError}
        />
        <div className='review-book-visit-payment-info-visit-row-container'>
          <label htmlFor='null' className='review-book-visit-payment-info-text bold'>
            {text.VISIT_CREDIT}
          </label>

          <label htmlFor='null' className='review-book-visit-payment-info-text'>
            {`-${visitCreditTotal}`}
          </label>
        </div>
      </div>

      <div className='review-book-visit-payment-info-visit-row-container'>
        <label htmlFor='null' className='review-book-visit-payment-info-total'>
          {text.TOTAL}
        </label>

        <label htmlFor='null' className='review-book-visit-payment-info-total'>
          {visitTotal}
        </label>
      </div>
    </div>
  )
}
